export default __webpack_public_path__ + "static/media/washing_hands.fb42c2b3.jpg";